import { Component } from '@angular/core';

@Component({
  selector: 'app-email-icon',
  templateUrl: './email-icon.component.html'
})
export class EmailIconComponent {
}
